<template>
  <span
    :class="['mask-icon', customClass]"
    :style="computedStyle"
    :role="role"
    :tabindex="tabindex"
    @click="$emit('click', $event)"
    @keydown.enter.prevent="emitClick"
    @keydown.space.prevent="emitClick"
    :title="title"
    :aria-hidden="ariaHidden"
  >
    <!-- fallback img for svg-support or when mask isn't supported -->
    <img :src="src" :alt="alt || ''" class="mask-fallback" />
  </span>
</template>

<script setup>
/* global defineProps, defineEmits */
import { computed } from 'vue';
const props = defineProps({
  src: { type: String, required: true },
  size: { type: [Number, String], default: 16 },
  alt: { type: String, default: '' },
  title: { type: String, default: '' },
  role: { type: String, default: '' },
  tabindex: { type: [Number, String], default: null },
  ariaHidden: { type: [Boolean, String], default: false },
  customClass: { type: String, default: '' },
});

const computedStyle = computed(() => {
  const size = typeof props.size === 'number' ? `${props.size}px` : props.size;
  return {
    width: size,
    height: size,
    display: 'inline-block',
    backgroundColor: 'currentColor',
    WebkitMaskImage: `url(${props.src})`,
    maskImage: `url(${props.src})`,
    WebkitMaskRepeat: 'no-repeat',
    maskRepeat: 'no-repeat',
    WebkitMaskPosition: 'center',
    maskPosition: 'center',
    WebkitMaskSize: 'contain',
    maskSize: 'contain',
  };
});

function emitClick(e) { emit('click', e) }

const emit = defineEmits(['click']);
</script>

<style scoped>
.mask-icon { vertical-align: middle }
.mask-icon .mask-fallback { width: 100%; height: 100%; display: none }
@supports (-webkit-mask-image: none) {
  .mask-fallback { display: none }
}
@supports not (-webkit-mask-image: none) {
  /* Browsers without mask support show fallback img instead */
  .mask-icon { display: inline-block }
  .mask-icon .mask-fallback { display: inline-block }
}
</style>
